import { render, staticRenderFns } from "./ValidationHeader.vue?vue&type=template&id=5b7adbb0&scoped=true&"
import script from "./ValidationHeader.vue?vue&type=script&lang=js&"
export * from "./ValidationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ValidationHeader.vue?vue&type=style&index=0&id=5b7adbb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7adbb0",
  null
  
)

export default component.exports